import { BodyText, Card, Flex, Heading } from '@utilitywarehouse/hearth-react';

import {
  SlideHeading,
  Terms,
} from '@components/PresentationRebrand/ContentSlide/slides/shared';
import { useBreakpoints } from '@utils/useBreakpoints';

import './styles.scss';
import desktopExampleBill from '/Presentation/Desktop/example-bill.png';
import mobileExampleBill from '/Presentation/Mobile/example-bill.png';

const heading = (
  <SlideHeading newlineOnWord>Introducing Utility Warehouse</SlideHeading>
);

export const IntroducingUtilityWarehouse = () => {
  const { breakpointsDown } = useBreakpoints();
  const isMobile = breakpointsDown.sm;
  const isTablet = breakpointsDown.md && !isMobile;

  return (
    <Flex
      direction="column"
      gap="200"
      className="introducing-utility-warehouse"
    >
      {isTablet && heading}
      <Flex
        gap={{ mobile: '150', tablet: '300' }}
        className="introducing-utility-warehouse__group"
      >
        <Flex
          direction="column"
          gap={{ mobile: '150', tablet: '250' }}
          className="introducing-utility-warehouse__text"
        >
          {!isTablet && heading}
          <Heading size={isMobile ? 'sm' : 'md'} asChild>
            <p>
              By bundling energy, broadband, mobile and insurance together, we
              reduce the cost and hassle of running a home
            </p>
          </Heading>
          <Flex direction="column" gap={{ mobile: '100', tablet: '150' }}>
            <BodyText size={{ mobile: 'md', tablet: 'lg' }}>
              One provider, one team to talk to and one great monthly bill.
            </BodyText>
            <BodyText size={{ mobile: 'md', tablet: 'lg' }}>
              When we do that well, we get talked about. And that's the power of
              our business - personal recommendations that earn people and
              businesses an extra income.
            </BodyText>
          </Flex>
        </Flex>
        <figure className="introducing-utility-warehouse__figure">
          <figcaption className="introducing-utility-warehouse__figure__caption">
            Example bill only. Prices may vary.
          </figcaption>
          <Card
            variant="emphasis"
            shadowColor="functional"
            colorScheme="neutralStrong"
            className="introducing-utility-warehouse__figure__card"
            paddingNone
          >
            <picture>
              <source media="(min-width: 992px)" srcSet={desktopExampleBill} />
              <img
                src={mobileExampleBill}
                alt="Example Utility Warehouse bill"
              />
            </picture>
          </Card>
        </figure>
      </Flex>

      <Terms />
    </Flex>
  );
};
